"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DetalhesContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@material-ui/core");
exports.DetalhesContainer = styled_components_1.default(core_1.Grid) `
  background: ${({ theme }) => theme.palette.primary.main};
  color: ${({ theme }) => theme.palette.primary.contrastText};
  font-size: 24px;

  h1 {
    color: ${({ theme }) => theme.palette.primary.contrastText};
    font-size: 56px;
    line-height: 60px;
  }
`;
//# sourceMappingURL=styles.js.map